import React, { useEffect, useState } from "react";

export default function Dashboard() {
  const [associations, setAssociations] = useState(0);
  const [comapnies, setCompanies] = useState(0);

  return (
    <div className="w-full">
      <iframe
        src="https://selego-metabase.cleverapps.io/public/dashboard/56262611-e420-4809-ad52-4d22859b0f18"
        frameborder="0"
        width="1200"
        height="750"
        allowtransparency
      ></iframe>
    </div>
  );
}
